// Intentionally inactive client plugin.
// The previous implementation was fully commented out, so Nuxt ignored this file
// and emitted a build warning. Keep a valid no-op export to preserve runtime
// behavior while keeping builds clean.
export default defineNuxtPlugin(() => {});
